<template>
  <div class="complaints-policy-wrapper">
    <div class="content-wrapper">
      <h1>Complaints Policy</h1>
    </div>
    <div class="content-wrapper complaints-policy_content">
      <nav>
        <ul>
          <li>
            <router-link to="#complaints-note">Complaints</router-link>
          </li>
          <li>
            <router-link to="#complex-complaints"
              >Complex complaints
            </router-link>
          </li>
          <li>
            <router-link to="#complaints-review"
              >Reviewing your complaint
            </router-link>
          </li>
          <li>
            <router-link to="#complaints-agreement"
              >Financial Ombudsman Service
            </router-link>
          </li>
          <li>
            <router-link to="#about-ombudsman"
              >About Ombudsman Service
            </router-link>
          </li>
          <li>
            <router-link to="#contact-ombudsman"
              >Contact Ombudsman Service
            </router-link>
          </li>
        </ul>
      </nav>
      <main>
        <ol>
          <div id="complaints-note">
            <li>
              <h4>Complaints</h4>
              <p>
                <strong>Please Note</strong>: if you have received e-mails from
                us and you wish to opt out, the simplest way is by entering your
                e-mail address on our
                <router-link title="unsubscribe" to="/unsubscribe"
                  >unsubscribe page
                </router-link>
                .
              </p>
              <ol>
                <li>
                  At Homeowner.Loans we endeavour to provide you with a great
                  service however if you are not satisfied with any aspect of
                  our service you can tell us about your concern by contacting
                  us either:
                  <ol>
                    <li>By phone on 0333 455 9960</li>
                    <li>
                      By sending an email to
                      <a title="e-mail us" href="mailto:info@homeowner.loans"
                        >info@homeowner.loans</a
                      >. For security reasons please do not include additional
                      personal information in any email to us.
                    </li>
                    <li>
                      By sending a letter to Homeowner Loans, 67 Wellgate,
                      Rotherham, England, S60 2LT.
                    </li>
                  </ol>
                </li>
                <li>
                  We aim to solve your concern straight away. However, if we
                  have not been able to resolve your complaint within three
                  working days, we will write to tell you:
                  <ol>
                    <li>Why we have not yet resolved your complaint</li>
                    <li>Who is dealing with your complaint</li>
                    <li>When we will contact you again</li>
                  </ol>
                </li>
                <li>
                  In most cases, complaints are dealt with within two weeks. We
                  will contact you regularly until your complaint has been
                  resolved.
                </li>
              </ol>
            </li>
          </div>
          <div id="complex-complaints">
            <li>
              <h4>Complex Complaints</h4>
              <ol>
                <li>
                  If your complaint is particularly complicated, it may take
                  longer to resolve.
                </li>
                <li>
                  If, together, we cannot reach an agreement, we will send you a
                  letter giving our reasons for the delay and an indication of
                  when we expect to provide a resolution. However, we may decide
                  to refer your complaint to our Management Team.
                </li>
                <li>
                  We aim to resolve your complaint as quickly as possible and to
                  your complete satisfaction.
                </li>
                <li>
                  If you're not satisfied with our action or explanation, the
                  member of staff dealing with your complaint will be happy to
                  discuss your concerns further.
                </li>
              </ol>
            </li>
          </div>
          <div id="complaints-review">
            <li>
              <h4>Reviewing your complaint - our Management Team</h4>
              <ol>
                <li>
                  If we are unable to resolve your complaint to your
                  satisfaction within three working days, your complaint will
                  automatically be referred to a higher level within our
                  Management team.
                </li>
                <li>
                  If their investigation is likely to take longer, they will
                  keep you fully informed of their progress.
                </li>
                <li>
                  Our Management team will issue our final response letter
                  within 8 weeks from your initial contact, which will explain
                  our final position.
                </li>
              </ol>
            </li>
          </div>
          <div id="complaints-agreement">
            <li>
              <h4>What to do if we can't reach an agreement together</h4>
              <ol>
                <li>
                  Homeowner.Loans recommends you use the Financial Ombudsman
                  Service.
                </li>
                <li>
                  Our aim is to resolve all complaints internally. However, if
                  we can't reach an agreement with you, our Client Finance
                  Management Team will send you a 'final response' letter within
                  8 weeks of your initial contact. This letter will clearly set
                  out our position in relation to your complaint.
                </li>
                <li>
                  If you are not satisfied with our suggested resolution you
                  have the right to refer your complaint to the Financial
                  Ombudsman Service.
                </li>
                <li>
                  If you want the Financial Ombudsman Service to look into your
                  complaint, you can do so free of charge but you must contact
                  them within six months of the date of any final response
                  issued. Although there are time limits for referring your
                  complaint to the Ombudsman, we will consent to the Ombudsman
                  considering your complaint even if you refer the complaint
                  outside the time limits.
                </li>
              </ol>
            </li>
          </div>
          <div id="about-ombudsman">
            <li>
              <h4>About the Financial Ombudsman Service</h4>
              <ol>
                <li>
                  The Financial Ombudsman Service offers a free independent
                  service and they can help with most financial complaints.
                  However, there are some limitations on what the Financial
                  Ombudsman Service can look into, and further information about
                  this can be obtained from them directly.
                </li>
                <li>
                  We are committed to resolving your complaint fairly and
                  quickly. In most cases this can be done if you contact us as
                  soon as possible. We will try to resolve your complaint by
                  listening to your concerns and agreeing a solution with you.
                </li>
              </ol>
            </li>
          </div>

          <div id="contact-ombudsman">
            <li>
              <h4>Contact the Financial Ombudsman Service</h4>
              <ol>
                <li>
                  Write - The Financial Ombudsman Service, Exchange Tower,
                  Harbour Exchange Square, Isle of Dogs, London E14 9SR.
                </li>
                <li>Call - 0800 023 4567</li>
                <li>
                  Email -
                  <a
                    class="color-blue"
                    title="complaints email"
                    href="mailto:complaint.info@financial-ombudsman.org.uk"
                    >complaint.info@financial-ombudsman.org.uk</a
                  >
                </li>
                <li>
                  Website -
                  <a
                    class="color-blue"
                    title="Financial Ombudsman Service"
                    href="http://www.financial-ombudsman.org.uk"
                    target="_blank"
                    rel="noopener"
                    >http://www.financial-ombudsman.org.uk</a
                  >
                </li>
              </ol>
            </li>
          </div>
        </ol>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: "ComplaintsPolicy"
};
</script>
<style lang="scss">
@import "../../scss/partials/policies";
</style>
